<div data-collapse="medium" data-animation="default" data-duration="400" data-w-id="0b6d58b7-c8f6-c4c2-5d56-04a30b2a6532" data-easing="ease" data-easing2="ease" role="banner" class="navigation no-color w-nav">
  <div class="container grid w-container layout-header">
    <div id="w-node-_0b6d58b7-c8f6-c4c2-5d56-04a30b2a6534-0b2a6532" class="flex-center">
      <a href="" class="brand left-margin w-nav-brand">
        <img src="assets/img/Merch-Loop4.png" width="110" sizes="(max-width: 479px) 44vw, (max-width: 991px) 110px, 100vw" srcset="assets/img/Merch-Loop4-p-500.png 500w, assets/img/Merch-Loop4-p-800.png 800w, assets/img/Merch-Loop4-p-1080.png 1080w, assets/img/Merch-Loop4.png 1158w" alt="">
      </a>
      <nav role="navigation" class="nav-menu w-nav-menu">
        <a [routerLink]="['/masterproducts']" class="nav-link w-nav-link">Catalog</a>
        <a [routerLink]="['/about-us']" class="nav-link w-nav-link">About</a>
        <a [routerLink]="['/how-it-works']" class="nav-link w-nav-link">How it Works</a>
        <div data-hover="false" data-delay="0" data-w-id="0b6d58b7-c8f6-c4c2-5d56-04a30b2a653a" class="w-dropdown">
          <div class="nav-link dropdown w-dropdown-toggle">
            <div class="arrow-icon w-icon-dropdown-toggle"></div>
            <div>Why Us</div>
          </div>
          <nav class="dropdown-list w-dropdown-list">
            <a [routerLink]="['/why-us']" class="dropdown-link w-dropdown-link">Why Us?</a>
            <a [routerLink]="['/features']" class="dropdown-link w-dropdown-link">Features</a>
          </nav>
        </div>
        <a [routerLink]="['/contact-us']" class="nav-link w-nav-link">Contact</a>
        <a (click)="openloginFormDialog()" class="sign-in-mobile">Sign In</a>
      </nav>
    </div>
    <div id="w-node-_0b6d58b7-c8f6-c4c2-5d56-04a30b2a6592-0b2a6532" class="flex-center">
      <div class="button-wrapper version-2">
        <a (click)="openloginFormDialog()" class="button w-button">Sign In →</a>
      </div>
      <div class="menu-button w-nav-button">
        <div class="line-1"></div>
        <div class="line-3"></div>
        <div class="line-2"></div>
      </div>
    </div>
  </div>
</div>
